import React from "react";
import "./styles.scss";

const Index = (props) => (
  <div className={`check-with-text-wrapper d-flex mb-3 ${props.size}`}>
    <div className={"cwt-icon-wrapper"}>{props.icon}</div>
    <div className={"cwt-text"}>{props.text}</div>
  </div>
);
export default Index;
